import { InviteInfoFeatureListItemType } from './types';

export const defaultFeatures: InviteInfoFeatureListItemType[] = [
    {
        iconName: 'Schedule',
        title: 'View Booking Details',
        description: 'Access booking summary, schedules, and key information.'
    },
    {
        iconName: 'DescriptionOutlined',
        title: 'Access Shared Documents Instantly',
        description: 'Any documents already shared by your supplier are available immediately after login.'
    },
    {
        iconName: 'People',
        title: 'Collaborate in One Place',
        description: 'Upload and share files directly within the booking.'
    },
    {
        iconName: 'AutorenewOutlined',
        title: 'Stay in Sync',
        description: 'New documents and updates are instantly visible to both you and your supplier.'
    }
];
